import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./setup/i18n";
import vuetify from "./setup/vuetify";
import "@socotec.io/socio-vue-components/style.css";
import { createOidc, useOidcStore } from "vue3-oidc";

import SocioManifest from "../socio-manifest.json";
import PackageJson from "../package.json";
import SocioVueComponents, { initializeTracingAndLogging } from "@socotec.io/socio-vue-components";
import { orm } from "./models/index.js";
import { createPinia } from "pinia";
import { oidcSettings } from "./setup/OIDCSettings";
import * as Sentry from "@sentry/vue";
import { getDefaultSentryConfig } from "@socotec.io/socio-grpc-api/configs";
import { createSentryPiniaPlugin } from "@sentry/vue";
import { stonlyIdentifyWidget } from "@/stonly/stonlyIdentifyWidget.js";
import wb from "./registerServiceWorker";

const faroSettings = {
  enableTelemetry: import.meta.env.VITE_APP_ENABLE_TELEMETRY,
  grafanaApiKey: import.meta.env.VITE_APP_GRAFANA_API_KEY,
  collectorUrl: import.meta.env.VITE_APP_COLLECTOR_URL,
  propagateUrls: import.meta.env.VITE_APP_PROPAGATE_URLS,
  grpcApiEnv: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
};

initializeTracingAndLogging(SocioManifest, PackageJson, faroSettings, {
  router,
});
createOidc({
  oidcSettings,
  auth: false,
  events: {
    addUserLoaded: (user) => {
      useOidcStore().actions.value.setUser(user);
      stonlyIdentifyWidget(user.profile.email, user.profile.name);
      Sentry.setUser({
        id: user.profile.usermanagementUuid,
        email: user.profile.email,
      });
    },
  },
  refreshToken: {
    enable: true,
    time: 30000,
  },
});

const app = createApp(App);
Sentry.init(
  getDefaultSentryConfig({
    app,
    dsn: "https://2bccd297cf7d1e62bd3e1284ff02dcb4@sentry.tools.infra-socotec.net/44",
    router,
    release: `audit-ppp@${import.meta.env.VITE_APP_VERSION}`,
    enabled: import.meta.env.MODE !== "development",
    environment: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  }),
);

const pinia = createPinia();
pinia.use(orm);
pinia.use(createSentryPiniaPlugin());

app.config.globalProperties.$workbox = wb;

app.use(router);
app.use(pinia);
app.use(i18n);
app.use(vuetify);
app.use(SocioVueComponents, i18n);

app.mount("#app");
